module.exports = __webpack_public_path__ + "img/icon_upload.9005ab4f.svg";